import React from 'react'

import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import SendIcon from '@mui/icons-material/Send'
import Box from '@mui/material/Box'

import { ChatItem } from '@/components/ui/chat/Chat'
import ChatBox from '@/components/ui/chat/ChatBox'
import ChatFeed from '@/components/ui/chat/ChatFeed'
import ChatInput from '@/components/ui/chat/ChatInput'
import Card from '@mui/material/Card'

export type MessengerProps = {
  dataSource: ChatItem[]
  onSendMessage: (message: string) => void
  disableInput: boolean
}

export function Messenger(props: MessengerProps) {
  const { dataSource, onSendMessage, disableInput } = props

  const handleSendMessage = (message: string) => {
    onSendMessage(message)
  }

  return (
    <Card sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        <ChatFeed>
          {dataSource.map((dataItem, index) => (
            <ChatBox key={`${dataItem.date} - ${index}`} {...dataItem} />
          ))}
        </ChatFeed>
      </Box>
      <Divider />
      {!disableInput && (
        <ChatInput
          onSendMessage={handleSendMessage}
          sendIcon={
            <IconButton>
              <SendIcon />
            </IconButton>
          }
          sx={{
            p: '5px',
          }}
        />
      )}
    </Card>
  )
}

export default Messenger
